import React from 'react';
import WorkDayDashboard from '../components/workday/WorkDayDashboard';
import './PhysiotherapistDashboard.css';

// Fizioterapeut - "Moj radni dan" sa zadacima fizioterapije.
const PhysiotherapistDashboard = () => (
  <div className="physiotherapist-dashboard">
    <WorkDayDashboard tasksEndpoint="/api/Task/physiotherapist-tasks" />
  </div>
);

export default PhysiotherapistDashboard;
